export const parseDateNumberToNumber = (
  value: number | Date | undefined,
): number => {
  if (typeof value === 'number') {
    return value;
  }
  if (value instanceof Date) {
    return value.getTime();
  }
  return 0;
};
